import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackAuthenticateClick, trackPlaceOfferClick } from './tracking';
import { modalOpen } from '../../actions/authentication';
import { UserRelated } from '../../components/UserRelated';
import { selectIsMyHomeRedesign } from '../../selectors/experiments/myHomeRedesign';
import { selectPageType } from '../../selectors/page';
import { selectUser } from '../../selectors/user';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { TUserState } from '../../types/user';
import { UserContainer } from '../UserContainer';
import { UtilitiesContainer } from '../UtilitiesContainer';
import { UtilitiesContainer as UtilitiesContainerRedesign } from '../UtilitiesContainer/Redesign';

export const UserRelatedContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const user = useSelector<IApplicationState, TUserState>(selectUser);
  const hasBlockedSanction = user.isAuthenticated ? user.hasBlockedSanction : false;
  const pageType = useSelector(selectPageType);
  const placeOfferLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.placeOffer);

  // TODO: После завершения эксперимента выпилить ненужное
  const isRedesignHeader = useSelector(selectIsMyHomeRedesign);
  const Utilities = isRedesignHeader ? UtilitiesContainerRedesign : UtilitiesContainer;

  const handlePlaceOfferClick = React.useCallback(() => trackPlaceOfferClick(pageType), [pageType]);
  const handleAuthenticateClick = React.useCallback(() => {
    dispatch(modalOpen());
    trackAuthenticateClick(pageType);
  }, [dispatch, pageType]);

  return (
    <UserRelated
      userMenu={user.isAuthenticated ? <UserContainer /> : null}
      utilities={<Utilities />}
      placeOfferLink={placeOfferLink}
      hasBlockedSanction={hasBlockedSanction}
      onPlaceOfferClick={handlePlaceOfferClick}
      onAuthenticateClick={handleAuthenticateClick}
    />
  );
};
